import sendBugAlert from './sendBugAlert'

class GlobalErrorCatcher {
  constructor() {
    this.app = null
    this.isVueBound = false

    this.setupGlobalHandlers()
  }

  setupGlobalHandlers() {
    // Erreurs JS globales (synchrones)
    window.onerror = (message, source, lineno, colno, error) => {
      sendBugAlert(error || message, {
        type: 'window.onerror',
        source,
        lineno,
        colno,
      })
    }

    // Promesses non catchées
    window.onunhandledrejection = event => {
      sendBugAlert(event.reason, {
        type: 'unhandledrejection',
      })
    }
  }

  setApp(app) {
    if (this.isVueBound || !app) return

    this.app = app

    app.config.errorHandler = (err, instance, info) => {
      sendBugAlert(err, {
        type: 'vue-error',
        info,
        component: instance?.type?.name || null,
      })
    }

    this.isVueBound = true
  }
}

export default new GlobalErrorCatcher()
